// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-timeline__logo{position:absolute;margin-top:-2px;border-radius:20%}[dir=ltr] .provider-timeline__logo{left:-14px}[dir=rtl] .provider-timeline__logo{right:-14px}.provider-timeline__titles{margin-inline-start:16px}", ""]);
// Exports
module.exports = exports;
